var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"radioButton"},[_vm._v(_vm._s(_vm.label)+" "),_c('input',{attrs:{"type":"radio","name":_vm.name},domProps:{"checked":_vm.isChecked},on:{"change":function($event){return _vm.inputChanged($event)}}}),_c('span',{staticClass:"checkmark"})])
}
var staticRenderFns = []

export { render, staticRenderFns }